import { useTheme } from 'styled-components';

import {
  Amount,
  Asset,
  AssetIcon,
  Price,
  Change,
  UserBalanceTableWrapper,
  BodyLoaderWrapper,
  HeaderLoader,
  HeaderLine,
  AssetName,
  BodyPrice,
  BodyBalance,
  BodyAmount,
  Balance,
  BodyChangeInPercentage,
  BodyChangeInUsd,
} from './styles';

export const UserBalanceTableLoader = () => {
  const { colors } = useTheme();
  return (
    <UserBalanceTableWrapper>
      <HeaderLoader
        backgroundColor={colors.surface.interactiveDefault}
        foregroundColor={colors.surface.pressed}
      >
        <Asset />
        <Price />
        <Balance />
        <Amount />
        <Change />
        <HeaderLine />
      </HeaderLoader>
      {[...Array(5)].map((item, i) => {
        return (
          <BodyLoaderWrapper
            key={i}
            backgroundColor={colors.surface.interactiveDefault}
            foregroundColor={colors.surface.pressed}
          >
            <AssetIcon />
            <AssetName />
            <BodyPrice />
            <BodyBalance />
            <BodyAmount />
            <BodyChangeInPercentage />
            <BodyChangeInUsd />
          </BodyLoaderWrapper>
        );
      })}
    </UserBalanceTableWrapper>
  );
};
